<div class="">
  <div class="header-container"></div>
</div>

<section class="saber-mas-section py-2 mt-0">
  <div class="container py-5">
    <div class="row px-0 mx-0 align-items-center g-5 mb-5">
      <div class="col-12 col-lg-6">
        <span class="badge bg-teal-soft text-teal mb-3 fs-20px">Sobre Centrix</span>
        <h1 class="display-4 fw-bold mb-4">Llevamos tu negocio al <span class="text-teal">siguiente nivel</span></h1>
        <p class="lead text-muted">
          En Centrix, no solo vendemos software; creamos herramientas que simplifican la vida de los emprendedores y empresarios. 
        </p>
        <p class="text-muted">
          Nacimos con el objetivo de cerrar la brecha tecnológica en el sector comercial peruano, ofreciendo sistemas que antes solo estaban al alcance de grandes corporaciones. Hoy, nuestra plataforma de facturación y ventas online ayuda a cientos de negocios a crecer de forma ordenada y legal.
        </p>
      </div>
      <div class="col-12 col-lg-6">
        <div class="img-experience rounded-4 shadow-lg d-flex align-items-center justify-content-center text-white p-5">
          <div class="text-center">
            <h2 class="display-1 fw-bold">10+</h2>
            <p class="fs-4">Años de experiencia tecnológica</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-4 mt-5">
      @for (item of pilares; track item.titulo) {
        <div class="col-12 col-md-4">
          <div class="card borderCard p-4 h-100 shadow-sm hover-up">
            <div class="fs-1 mb-3">{{ item.icon }}</div>
            <h3 class="fw-bold h5">{{ item.titulo }}</h3>
            <p class="text-muted mb-0 small">{{ item.desc }}</p>
          </div>
        </div>
      }
    </div>

    <div class="row px-0 mx-0 mt-5">
      <div class="col-12 text-center py-5 bg-teal rounded-4 text-white">
        <h2 class="fw-bold mb-3">¿Listo para empezar?</h2>
        <p class="mb-4 opacity-75">Únete a la familia Centrix y transforma tu manera de vender.</p>
        <button class="btn btn-light btn-lg px-5 fw-bold text-teal">Ver Planes</button>
      </div>
    </div>
  </div>
</section>